module.exports = __webpack_public_path__ + "media/scholarship_winners/edelma-sw-d3537134.png";